module.exports = __webpack_public_path__ + "static/08-a8ecf31fef415842ba8ff216efde08f7.jpg";